/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-05-15 11:53:00
 * @FilePath: \hippo-web-admin\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * axios实例
 */
import axios from 'axios';
import router from '@/router';
import { MessageBox, Message } from 'element-ui';
import { TOKEN_HEADER_NAME, EXPORT_PDF_TOKEN } from '@/config/setting';
import { getToken, removeToken } from './token-util';
import sk from 'ele-admin/packages/lang/sk';

const service = axios.create({
  headers: {
    'Content-Type': 'application/json;'
  },
  baseURL:
    process.env.NODE_ENV === 'development'
      ? ''
      : process.env.VUE_APP_API_BASE_URL,
  timeout: 10 * 60 * 1000
});

/* 跳转到登录页面 */
const goLogin = function (from) {
  removeToken();
  router.push({
    path: '/login',
    query: from ? { from } : undefined
  });
};

const getLangCode = (value) => {
  return {
    zh: 'zh_CN',
    en: 'en_US',
    cs: 'cs',
    it: 'it',
    ar: 'ar',
    sl: 'sl',
    hr: 'hr',
    bg: 'bg',
    hy: 'hy',
    fr: 'fr',
    hu: 'hu',
    pt: 'pt',
    mk: 'mk', // 马其顿语
    sr: 'sr', // 塞尔维亚语
    sk: 'sk', // 斯洛伐克语
    tr: 'tr' // 土耳其语
  }[value];
};

/* 添加请求拦截器 */
service.interceptors.request.use(
  (config) => {
    // 添加时区
    config.headers.common['timeZone'] =
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers.common['lanCode'] = getLangCode(
      localStorage.getItem('hippoLang')
    );
    // 添加token到header
    let token = getToken();
    if (
      router.currentRoute.path.indexOf('/reportPdf/') > -1 ||
      router.currentRoute.path.indexOf('/report/') > -1
    ) {
      token = router.currentRoute.query[EXPORT_PDF_TOKEN] ?? token;
    }
    if (token && config.headers) {
      config.headers.common[TOKEN_HEADER_NAME] = token;
    }
    const data = config.data;
    // 转换请求参数为formdata
    if (data && config.headers['Content-Type'].indexOf('json') < 0) {
      let formData = new FormData();
      for (let i = 0, len = Object.keys(data).length; i < len; i++) {
        let key = Object.keys(data)[i];
        formData.append(key, data[key]);
      }
      config.data = formData;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/* 添加响应拦截器 */
service.interceptors.response.use((res) => {
  // 登录过期处理
  if (res.data.code === 300) {
    const currentPath = router.currentRoute.path;
    if (currentPath === '/') {
      goLogin();
    } else {
      let langs = localStorage.getItem('hippoLang') || 'en';
      if (langs == 'zh') {
        MessageBox.alert('登录状态已过期，请退出重新登录！', '系统提示', {
          confirmButtonText: '重新登录',
          callback: (action) => {
            if (action === 'confirm') {
              goLogin(currentPath);
            }
          },
          beforeClose: () => {
            MessageBox.close();
          }
        });
      } else if (langs == 'en') {
        MessageBox.alert(
          'Your login status has expired, please log out and log in again!',
          'System prompts',
          {
            confirmButtonText: 'Re-login',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'cs') {
        MessageBox.alert(
          'Váš stav přihlášení vypršel, odhlaste se a znovu se přihlaste!',
          'systémový prompt',
          {
            confirmButtonText: 'Znovu se přihlaste',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'it') {
        MessageBox.alert(
          'Il tuo stato di accesso è scaduto, effettua il logout e accedi nuovamente!',
          'Richieste di sistema',
          {
            confirmButtonText: "Effettua nuovamente l'accesso",
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'ar') {
        MessageBox.alert(
          'انتهت صلاحية حالة تسجيل الدخول الخاصة بك، يرجى تسجيل الخروج وتسجيل الدخول مرة أخرى!',
          'نظام المطالبات',
          {
            confirmButtonText: 'إعادة تسجيل الدخول',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'sl') {
        MessageBox.alert(
          'Vaša prijava je potekla, odjavite se in se znova prijavite!',
          'Sistemski pozivi',
          {
            confirmButtonText: 'Ponovna prijava',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'hr') {
        MessageBox.alert(
          'Vaš je status prijave istekao, molimo vas da se odjavite i ponovno prijavite!',
          'Sistemske upute',
          {
            confirmButtonText: 'Ponovna prijava',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'bg') {
        MessageBox.alert(
          'Вашият статус за вход е изтекъл, моля, излезте и влезте отново!',
          'Системни подкани',
          {
            confirmButtonText: 'Влезте отново',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'hy') {
        MessageBox.alert(
          'Ձեր մուտքի կարգավիճակը լրացել է, խնդրում ենք դուրս գալ և կրկին մուտք գործել։',
          'Համակարգի հուշումներ',
          {
            confirmButtonText: 'Վերամուտք գործել',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'fr') {
        MessageBox.alert(
          'Votre statut de connexion a expiré, veuillez vous déconnecter et vous reconnecter !',
          'Invites système',
          {
            confirmButtonText: 'Se reconnecter',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'hu') {
        MessageBox.alert(
          'A bejelentkezési állapota lejárt, kérjük, jelentkezzen ki, majd jelentkezzen be újra!',
          'Rendszerkérések',
          {
            confirmButtonText: 'Újrajelentkezés',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'pt') {
        MessageBox.alert(
          'O seu estado de login expirou, saia e faça login novamente!',
          'Prompts do sistema',
          {
            confirmButtonText: 'Re-login',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'mk') {
        MessageBox.alert(
          'Вашиот статус на најавување е истечен, одјавете се и најавете се повторно!',
          'Системски инструкции',
          {
            confirmButtonText: 'Повторно најавување',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'sr') {
        MessageBox.alert(
          'Ваш статус пријаве је истекао, молимо вас да се одјавите и поново пријавите!',
          'Системски упити',
          {
            confirmButtonText: 'Поново се пријавите',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'sk') {
        MessageBox.alert(
          'Platnosť vášho prihlásenia vypršala, odhláste sa a znova prihláste!',
          'Systémové výzvy',
          {
            confirmButtonText: 'Znovu sa prihlásiť',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      } else if (langs == 'tr') {
        MessageBox.alert(
          'Giriş durumunuz sona erdi, lütfen çıkış yapıp tekrar giriş yapın!',
          'Sistem istemleri',
          {
            confirmButtonText: 'Tekrar giriş yap',
            callback: (action) => {
              if (action === 'confirm') {
                goLogin(currentPath);
              }
            },
            beforeClose: () => {
              MessageBox.close();
            }
          }
        );
      }
    }
    return Promise.reject(new Error(res.data.message));
  }
  if (res.status !== 200 || res.data.code !== 200) {
    Message.error(res.data.message);
    return;
  }
  return res.data;
});

export default service;
